import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AxiosResponse } from 'axios'

import { getRasaStatus } from '../../api/training'
import useApiCall from '../../api/useApiCall'
import {
    TrainingStatusEnum,
    useRasaStatusStore,
} from '../../stores/rasaStatusStore'

import { joinClassNames } from '../../utils/styles'
import styles from './status-button.module.scss'

interface ITrainingButtonProps {
    title: string
    submitRequest: () => Promise<AxiosResponse<TrainingStatusEnum>>
    passive?: boolean
}

function StatusButton(props: ITrainingButtonProps) {
    const { title, submitRequest, passive } = props

    const { t } = useTranslation()

    const [{ status }, { setStatus }] = useRasaStatusStore()

    const [, { refetch }] = useApiCall(getRasaStatus, setStatus)

    useEffect(() => {
        if (passive) {
            return
        }

        const intervalId = setInterval(
            () => {
                refetch()
            },
            status === TrainingStatusEnum.TRAINING ? 5000 : 10000
        )

        return () => {
            clearInterval(intervalId)
        }
    }, [status, refetch, passive])

    const handleTrainingStarted = () => {
        submitRequest().then((res) => setStatus(res.data))
    }

    const statusContent = (status: TrainingStatusEnum | undefined) => {
        if (!status) return

        switch (status) {
            case TrainingStatusEnum.READY:
                return t('ready')
            case TrainingStatusEnum.TRAINING:
                return t('training_continues')
            case TrainingStatusEnum.LOADING_MODEL:
                return t('loading_model')
        }
    }

    return (
        <div className={styles.statusButton__wrapper}>
            {statusContent(status)}
            <button
                onClick={handleTrainingStarted}
                className={joinClassNames(styles.statusButton)}
                disabled={status !== TrainingStatusEnum.READY}
            >
                {title}
            </button>
        </div>
    )
}

export default StatusButton
